export default __webpack_public_path__ + "static/media/note.d849a9fb.svg";